import Layout from './Layout';
import Head from './Head';
import Logo from './Logo';
import Section from './Section';

export {
  Head,
  Logo,
  Section,
};

export default Layout;
